/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const OPEN_CHAT_EVENT = 'open-conversational-chat';

// Entry points specify intent; only the host knows iframe routes and messages.
export const openChat = ({ experience = 'customerService', source = 'link' } = {}) => {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(OPEN_CHAT_EVENT, {
        detail: { experience, source },
    }));
};
